// import { useMemo, useRef, useState, useEffect } from "react";
// import { createPortal } from "react-dom";
// import DashboardLayout from "../../../components/DashboardLayout";
// import { useNavigate, useParams } from "react-router-dom";
// import FleetrifyCard from "../../../components/Card";
// import { FleetrifyButton } from "../../../components/Button/customButton";
// import FleetrifyToggleSwitch from "../../../components/Switch/ToggleSwitch";
// import { FleetrifyModal } from "../../../components/Modal/modal";
// import {
//   useGetServiceByIdQuery,
//   useGetAllServiceTypesQuery,
//   useUpdateServiceMutation,
//   useDeleteServiceMutation,
// } from "../../../redux/services/serviceApi";
// import { useStaffController } from "../../../controllers/useStaffController";
// import { ArrowLeft, ChevronDown, Eye, Pencil, Printer, Trash2, X } from "lucide-react";
// import { toast } from "sonner";
// import { usePermission } from "../../../hooks/usePermission";

// function useDropdownPosition(
//   triggerRef: React.RefObject<HTMLElement | null>,
//   open: boolean
// ) {
//   const [pos, setPos] = useState({ top: 0, left: 0, width: 0 });
//   useEffect(() => {
//     if (!open || !triggerRef.current) return;
//     const rect = triggerRef.current.getBoundingClientRect();
//     const spaceBelow = window.innerHeight - rect.bottom;
//     const dropdownH = 220;
//     const top = spaceBelow < dropdownH
//       ? rect.top + window.scrollY - dropdownH - 4
//       : rect.bottom + window.scrollY + 4;
//     setPos({ top, left: rect.left + window.scrollX, width: rect.width });
//   }, [open, triggerRef]);
//   return pos;
// }

// const PortalSelect = ({
//   value, options, onChange, placeholder = "Select...", disabled = false,
// }: {
//   value: string;
//   options: { label: string; value: string }[];
//   onChange: (val: string) => void;
//   placeholder?: string;
//   disabled?: boolean;
// }) => {
//   const [open, setOpen] = useState(false);
//   const triggerRef = useRef<HTMLButtonElement>(null);
//   const pos = useDropdownPosition(triggerRef, open);
//   const selected = options.find((o) => o.value === value);

//   return (
//     <div className="w-full">
//       <button ref={triggerRef} type="button" disabled={disabled}
//         onClick={() => !disabled && setOpen((p) => !p)}
//         className={`w-full flex items-center justify-between gap-2 px-3 py-2 text-sm border rounded-md bg-white transition-colors
//           ${disabled ? "cursor-default border-gray-200 text-gray-400" : "border-gray-300 hover:border-[#143887] cursor-pointer"}
//           ${open ? "border-[#143887] ring-1 ring-[#143887]/20" : ""}`}
//       >
//         <span className={selected ? "text-[#00032A]" : "text-gray-400"}>{selected?.label ?? placeholder}</span>
//         <ChevronDown size={14} className={`text-gray-400 flex-shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />
//       </button>
//       {open && createPortal(
//         <>
//           <div className="fixed inset-0 z-[999]" onClick={() => setOpen(false)} />
//           <div className="absolute bg-white border border-gray-200 rounded-md shadow-xl z-[1000] overflow-y-auto"
//             style={{ top: pos.top, left: pos.left, width: pos.width, maxHeight: 220 }}>
//             {options.map((opt) => (
//               <button key={opt.value} type="button"
//                 onClick={() => { onChange(opt.value); setOpen(false); }}
//                 className={`w-full text-left px-4 py-2.5 text-sm hover:bg-[#e4ebf8] hover:text-[#143887] transition-colors
//                   ${opt.value === value ? "bg-[#e4ebf8] text-[#143887] font-medium" : "text-[#00032A]"}`}>
//                 {opt.label}
//               </button>
//             ))}
//           </div>
//         </>,
//         document.body
//       )}
//     </div>
//   );
// };

// const PortalMultiSelect = ({
//   value, options, onChange, placeholder = "Select options...", disabled = false,
// }: {
//   value: string[];
//   options: { label: string; value: string }[];
//   onChange: (vals: string[]) => void;
//   placeholder?: string;
//   disabled?: boolean;
// }) => {
//   const [open, setOpen] = useState(false);
//   const triggerRef = useRef<HTMLDivElement>(null);
//   const pos = useDropdownPosition(triggerRef, open);

//   const toggle = (val: string) =>
//     onChange(value.includes(val) ? value.filter((v) => v !== val) : [...value, val]);
//   const remove = (val: string, e: React.MouseEvent) => { e.stopPropagation(); onChange(value.filter((v) => v !== val)); };
//   const getLabel = (val: string) => options.find((o) => o.value === val)?.label ?? val;

//   return (
//     <div className="w-full">
//       <div ref={triggerRef} onClick={() => !disabled && setOpen((p) => !p)}
//         className={`w-full min-h-[38px] flex flex-wrap items-center gap-1.5 px-3 py-1.5 border rounded-md bg-white transition-colors
//           ${disabled ? "cursor-default border-gray-200" : "border-gray-300 hover:border-[#143887] cursor-pointer"}
//           ${open ? "border-[#143887] ring-1 ring-[#143887]/20" : ""}`}>
//         {value.length === 0 ? (
//           <span className="text-sm text-gray-400 py-0.5">{placeholder}</span>
//         ) : value.map((val) => (
//           <span key={val} className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-[#e4ebf8] text-[#143887] text-xs font-medium border border-[#c5d5ef]">
//             {getLabel(val)}
//             {!disabled && (
//               <button type="button" onClick={(e) => remove(val, e)} className="hover:text-red-500 transition-colors ml-0.5">
//                 <X size={10} />
//               </button>
//             )}
//           </span>
//         ))}
//         {!disabled && <ChevronDown size={14} className={`text-gray-400 ml-auto flex-shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />}
//       </div>
//       {open && createPortal(
//         <>
//           <div className="fixed inset-0 z-[999]" onClick={() => setOpen(false)} />
//           <div className="absolute bg-white border border-gray-200 rounded-md shadow-xl z-[1000] overflow-y-auto"
//             style={{ top: pos.top, left: pos.left, width: pos.width, maxHeight: 220 }}>
//             {options.map((opt) => {
//               const sel = value.includes(opt.value);
//               return (
//                 <button key={opt.value} type="button" onClick={() => toggle(opt.value)}
//                   className={`w-full text-left px-4 py-2.5 text-sm flex items-center gap-2.5 hover:bg-[#e4ebf8] transition-colors
//                     ${sel ? "text-[#143887] font-medium" : "text-[#00032A]"}`}>
//                   <span className={`w-4 h-4 rounded border flex-shrink-0 flex items-center justify-center transition-colors
//                     ${sel ? "bg-[#143887] border-[#143887]" : "border-gray-300 bg-white"}`}>
//                     {sel && <svg viewBox="0 0 10 10" className="w-2.5 h-2.5 text-white" fill="none"><path d="M1.5 5l2.5 2.5 5-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>}
//                   </span>
//                   {opt.label}
//                 </button>
//               );
//             })}
//           </div>
//         </>,
//         document.body
//       )}
//     </div>
//   );
// };

// const EditableText = ({
//   value, onSave, canEdit, type = "text", prefix,
// }: {
//   value: string; onSave: (val: string) => void; canEdit: boolean; type?: string; prefix?: string;
// }) => {
//   const [editing, setEditing] = useState(false);
//   const [draft, setDraft] = useState(value);
//   const commit = () => { onSave(draft); setEditing(false); };

//   if (editing) {
//     return (
//       <div className="flex items-center gap-1.5 w-full max-w-sm">
//         {prefix && <span className="text-gray-600 font-semibold text-sm flex-shrink-0">{prefix}</span>}
//         <input autoFocus type={type} value={draft}
//           onChange={(e) => setDraft(e.target.value)}
//           onBlur={commit}
//           onKeyDown={(e) => { if (e.key === "Enter") commit(); if (e.key === "Escape") setEditing(false); }}
//           className="flex-1 text-sm text-[#00032A] border border-[#143887] rounded-md px-3 py-1.5 outline-none focus:ring-2 focus:ring-[#143887]/20 bg-white"
//         />
//       </div>
//     );
//   }

//   return (
//     <button type="button" disabled={!canEdit}
//       onClick={() => { setDraft(value); setEditing(true); }}
//       className="group flex items-center gap-2 text-left disabled:cursor-default">
//       <span className="text-sm text-[#00032A] group-hover:text-[#143887] transition-colors">{prefix}{value}</span>
//       {canEdit && <Pencil size={12} className="text-gray-300 group-hover:text-[#143887] opacity-0 group-hover:opacity-100 transition-all flex-shrink-0" />}
//     </button>
//   );
// };

// const FieldRow = ({ label, children }: { label: string; children: React.ReactNode }) => (
//   <div className="flex flex-col md:flex-row md:items-start py-4 border-b border-gray-100 last:border-0 gap-1.5 md:gap-0">
//     <span className="text-sm text-gray-500 font-medium md:w-56 md:flex-shrink-0 md:pt-1.5">{label}</span>
//     <div className="flex-1 min-w-0">{children}</div>
//   </div>
// );

// const ViewService = () => {
//   const navigate = useNavigate();
//   const { serviceId } = useParams<{ serviceId: string }>();

//   const [isActive, setIsActive] = useState<boolean | null>(null);
//   const [hasStatusChanged, setHasStatusChanged] = useState(false);
//   const [hasFieldChanges, setHasFieldChanges] = useState(false);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [isDeleting, setIsDeleting] = useState(false);
//   const [isDeleted, setIsDeleted] = useState(false);

//   const [editedServiceTypeId, setEditedServiceTypeId] = useState<string | null>(null);
//   const [editedDescription, setEditedDescription] = useState<string | null>(null);
//   const [editedFrom, setEditedFrom] = useState<string | null>(null);
//   const [editedTo, setEditedTo] = useState<string | null>(null);
//   const [editedPrice, setEditedPrice] = useState<string | null>(null);
//   const [editedPriceModel, setEditedPriceModel] = useState<string | null>(null);
//   const [editedVehicleTypes, setEditedVehicleTypes] = useState<string[] | null>(null);
//   const [editedStaffMembers, setEditedStaffMembers] = useState<string[] | null>(null);

//   const { data: selectedService, isLoading, isError } = useGetServiceByIdQuery(serviceId!, { skip: !serviceId });
//   const { data: serviceTypes } = useGetAllServiceTypesQuery(undefined, { skip: !selectedService });
//   const { staffData } = useStaffController();

//   const PRICE_MODEL_OPTIONS = [
//     { label: "Dynamic", value: "dynamic" },
//     { label: "Fixed", value: "fixed" },
//     // { label: "Fixed Per KM", value: "fixed_per_km" },
//     // { label: "Subscription", value: "subscription" },
//   ];

//   const VEHICLE_TYPE_OPTIONS = [
//     { label: "Car", value: "car" },
//     { label: "Truck", value: "truck" },
//     { label: "Bike", value: "bike" },
//     { label: "Van", value: "van" },
//     // { label: "Trailer", value: "trailer" },
//     // { label: "Ship", value: "ship" },
//     // { label: "Tricycle", value: "tricycle" },
//   ];

//   const staffOptions = useMemo(() =>
//     (staffData ?? []).map((s: any) => ({
//       label: `${s.firstName ?? ""} ${s.lastName ?? ""}`.trim() || s.email || s.id,
//       value: s.id,
//     })), [staffData]);

//   const serviceCategoryOptions = useMemo(() =>
//     (serviceTypes ?? []).map((t) => ({ label: t.name, value: t.id })),
//     [serviceTypes]);

//   const [updateService, { isLoading: isUpdatingService }] = useUpdateServiceMutation();
//   const [deleteService] = useDeleteServiceMutation();
//   const { hasPermission } = usePermission();
//   const canUpdate = hasPermission("update service");
//   const canDelete = hasPermission("delete service");

//   const initialIsActive = String(selectedService?.status ?? "active").toLowerCase() !== "inactive";
//   const currentIsActive = isActive ?? initialIsActive;
//   const mark = () => setHasFieldChanges(true);

//   const currentServiceTypeId = editedServiceTypeId ?? selectedService?.service_type_id ?? "";
//   const currentVehicleTypes: string[] = useMemo(() => {
//     if (editedVehicleTypes !== null) return editedVehicleTypes;
//     const raw = selectedService?.vehicle_type ?? "";
//     return raw ? raw.split(",").map((v: string) => v.trim()).filter(Boolean) : [];
//   }, [editedVehicleTypes, selectedService]);
//   const currentStaffMembers: string[] = editedStaffMembers ?? selectedService?.staff_members_id ?? [];
//   const serviceTypeName = serviceCategoryOptions.find((o) => o.value === currentServiceTypeId)?.label || "—";
//   const currentServiceName = selectedService?.service_type_name ?? serviceTypeName ?? "—";

//   const formatDate = (d: string) => {
//     try { return new Date(d).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" }); }
//     catch { return d; }
//   };
//   const formatPrice = (p: string) => {
//     try { return parseFloat(editedPrice ?? p).toLocaleString("en-NG", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
//     catch { return p; }
//   };
//   const capitalize = (s: string) => s ? s.charAt(0).toUpperCase() + s.slice(1) : "N/A";

//   const handleUpdate = async () => {
//     if (!service) return;
//     if (!canUpdate) { toast.error("You don't have permission to update a service"); return; }
//     if (!hasStatusChanged && !hasFieldChanges) { toast.info("No changes to update"); return; }

//     const payload: any = {};
//     if (hasStatusChanged) payload.status = currentIsActive ? "active" : "inactive";
//     if (editedServiceTypeId) payload.service_type_id = editedServiceTypeId;
//     if (editedDescription !== null) payload.description = editedDescription;
//     if (editedFrom !== null) payload.from = editedFrom;
//     if (editedTo !== null) payload.to = editedTo;
//     if (editedPrice !== null) payload.price = editedPrice;
//     if (editedPriceModel !== null) payload.price_model = editedPriceModel;
//     if (editedVehicleTypes !== null) payload.vehicle_type = editedVehicleTypes.join(", ");
//     if (editedStaffMembers !== null) payload.staff_members_id = editedStaffMembers;

//     try {
//       await updateService({ id: service.id, payload }).unwrap();
//       toast.success("Service updated successfully!");
//       setTimeout(() => navigate("/services"), 500);
//     } catch (error: any) {
//       toast.error(error?.data?.message || "Failed to update service");
//     }
//   };

//   const handleDeleteConfirm = async () => {
//     if (!service) return;
//     if (!canDelete) { toast.error("You don't have permission to delete a service"); return; }
//     try {
//       setIsDeleting(true);
//       setIsDeleted(true); // mark as deleted so refetch errors are ignored
//       await deleteService(service.id).unwrap();
//       toast.success("Service deleted successfully!");
//       setShowDeleteModal(false);
//       navigate("/services");
//     } catch (error: any) {
//       setIsDeleted(false); // reset if delete actually failed
//       toast.error(error?.data?.message || "Failed to delete service");
//     } finally {
//       setIsDeleting(false);
//     }
//   };

//   if (isLoading) {
//     return (
//       <DashboardLayout title="Services" containerClass="pb-10">
//         <FleetrifyCard cardContainerClass="mt-5 mb-10">
//           <div className="flex flex-col items-center justify-center py-20">
//             <div className="h-10 w-10 border-4 border-gray-300 border-t-[#143887] rounded-full animate-spin" />
//             <p className="text-sm text-gray-500 mt-4">Loading service details...</p>
//           </div>
//         </FleetrifyCard>
//       </DashboardLayout>
//     );
//   }

//   if (!isDeleted && (isError || !selectedService)) {
//     return (
//       <DashboardLayout title="Service Not Found">
//         <FleetrifyCard cardContainerClass="mt-5 mb-10">
//           <div className="flex flex-col items-center justify-center py-20">
//             <div className="text-6xl text-gray-300 mb-4">🔍</div>
//             <h2 className="text-2xl font-bold text-gray-700 mb-2">Service Not Found</h2>
//             <p className="text-gray-500 mb-6">The service you're looking for does not exist.</p>
//             <FleetrifyButton onClick={() => navigate("/services")} className="bg-[#143887] hover:bg-[#0f2d6b]">
//               Back to Services
//             </FleetrifyButton>
//           </div>
//         </FleetrifyCard>
//       </DashboardLayout>
//     );
//   }

//   const hasAnyChange = hasStatusChanged || hasFieldChanges;
//   const service = selectedService!; // safe — guarded above

//   return (
//     <DashboardLayout title="Services" containerClass="pb-10">
//       <div className="mt-5 mb-4">
//         <button onClick={() => navigate("/services")}
//           className="flex items-center gap-2 text-sm text-gray-500 hover:text-[#143887] font-medium transition-colors group">
//           <span className="flex items-center justify-center w-7 h-7 rounded-full border border-gray-200 group-hover:border-[#143887] group-hover:bg-[#e4ebf8] transition-all">
//             <ArrowLeft size={14} />
//           </span>
//           Back to Services
//         </button>
//       </div>

//       <FleetrifyCard cardContainerClass="mb-10">
//         {/* Header */}
//         <div className="px-4 md:px-6 py-4 border-b border-gray-200 flex items-center justify-between">
//           <div className="flex items-center gap-3">
//             <div className="p-1.5 rounded-sm bg-[#e4ebf8]">
//               <Eye size={20} className="text-[#143887]" />
//             </div>
//             {hasAnyChange && (
//               <span className="text-xs text-orange-500 font-medium bg-orange-50 border border-orange-200 px-2 py-0.5 rounded-full">
//                 Unsaved changes
//               </span>
//             )}
//           </div>
//           <div className="flex items-center gap-3">
//             <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border ${
//               currentIsActive ? "bg-green-50 text-green-700 border-green-200" : "bg-red-50 text-red-600 border-red-200"
//             }`}>
//               <span className={`w-1.5 h-1.5 rounded-full ${currentIsActive ? "bg-green-500" : "bg-red-500"}`} />
//               {currentIsActive ? "Active" : "Inactive"}
//             </span>
//             <button onClick={() => window.print()} className="text-gray-500 p-2 bg-gray-100 rounded-sm hover:bg-gray-200 transition-colors">
//               <Printer size={16} />
//             </button>
//           </div>
//         </div>

//         {/* Body */}
//         <div className="px-4 md:px-6 py-4">
//           {canUpdate && (
//             <p className="text-xs text-gray-400 mb-2 flex items-center gap-1">
//               <Pencil size={11} /> Click any value to edit
//             </p>
//           )}

//           <FieldRow label="Service">
//             <span className="text-sm text-[#00032A]">{currentServiceName}</span>
//           </FieldRow>

//           <FieldRow label="Service Category">
//             <PortalSelect value={currentServiceTypeId} options={serviceCategoryOptions}
//               onChange={(val) => { setEditedServiceTypeId(val); mark(); }}
//               placeholder="Select category" disabled={!canUpdate} />
//           </FieldRow>

//           <FieldRow label="Description">
//             <EditableText value={editedDescription ?? service.description ?? ""}
//               onSave={(v) => { setEditedDescription(v); mark(); }} canEdit={canUpdate} />
//           </FieldRow>

//           <FieldRow label="From">
//             <EditableText value={capitalize(editedFrom ?? service.from ?? "")}
//               onSave={(v) => { setEditedFrom(v); mark(); }} canEdit={canUpdate} />
//           </FieldRow>

//           <FieldRow label="To">
//             <EditableText value={capitalize(editedTo ?? service.to ?? "")}
//               onSave={(v) => { setEditedTo(v); mark(); }} canEdit={canUpdate} />
//           </FieldRow>

//           <FieldRow label="Price">
//             <EditableText value={formatPrice(service.base_price === "0.00" ? service.price : service.base_price)}
//               onSave={(v) => { setEditedPrice(v); mark(); }} canEdit={canUpdate}
//               type="number" prefix="₦" />
//           </FieldRow>

//           <FieldRow label="Price Model">
//             <PortalSelect value={editedPriceModel ?? service.price_model ?? ""}
//               options={PRICE_MODEL_OPTIONS}
//               onChange={(val) => { setEditedPriceModel(val); mark(); }}
//               placeholder="Select price model" disabled={!canUpdate} />
//           </FieldRow>

//           <FieldRow label="Vehicle Type">
//             <PortalMultiSelect value={currentVehicleTypes} options={VEHICLE_TYPE_OPTIONS}
//               onChange={(vals) => { setEditedVehicleTypes(vals); mark(); }}
//               placeholder="Select vehicle types" disabled={!canUpdate} />
//           </FieldRow>

//           <FieldRow label="Date Added">
//             <span className="text-sm text-[#00032A]">{formatDate(service.created_at)}</span>
//           </FieldRow>

//           <FieldRow label="Staff Members">
//             <PortalMultiSelect value={currentStaffMembers} options={staffOptions}
//               onChange={(vals) => { setEditedStaffMembers(vals); mark(); }}
//               placeholder="Select staff members" disabled={!canUpdate} />
//           </FieldRow>

//           {/* Status toggle — commented out; status managed via the header badge
//           <FieldRow label="Status">
//             <div className="flex items-center gap-3">
//               <FleetrifyToggleSwitch value={currentIsActive} onChange={(v) => {
//                 if (!canUpdate) { toast.error("You don't have permission to update a service"); return; }
//                 setIsActive(v);
//                 setHasStatusChanged(v !== initialIsActive);
//               }} />
//               <span className="text-sm text-[#00032A]">{currentIsActive ? "Active" : "Inactive"}</span>
//             </div>
//           </FieldRow>
//           */}

//           {/* Action buttons */}
//           <div className="flex flex-col sm:flex-row gap-3 mt-6 pt-4 border-t border-gray-100">
//             <FleetrifyButton variant="outline"
//               className="w-full sm:w-32 border-[#143887] text-[#143887] hover:bg-[#143887] hover:text-white transition-colors"
//               onClick={handleUpdate} disabled={isUpdatingService || !canUpdate}>
//               {isUpdatingService ? "Updating..." : "Update"}
//             </FleetrifyButton>
//             <FleetrifyButton variant="destructive"
//               className="w-full sm:w-32 bg-red-600 hover:bg-red-700"
//               onClick={() => {
//                 if (!canDelete) { toast.error("You don't have permission to delete a service"); return; }
//                 setShowDeleteModal(true);
//               }}
//               disabled={isUpdatingService || !canDelete}>
//               Delete
//             </FleetrifyButton>
//           </div>
//         </div>
//       </FleetrifyCard>

//       {/* ── Delete confirmation modal ── */}
//       <FleetrifyModal
//         isOpen={showDeleteModal}
//         title="Delete Service"
//         onClose={() => setShowDeleteModal(false)}
//         className="max-w-md h-fit"
//         enableOutsideClick={false}
//       >
//         <div className="flex flex-col items-center justify-center p-6 text-center space-y-4">
//           {/* Icon */}
//           <div className="w-14 h-14 rounded-full bg-red-50 border border-red-200 flex items-center justify-center">
//             <Trash2 size={22} className="text-red-500" />
//           </div>

//           {/* Copy */}
//           <div>
//             <p className="text-gray-800 font-semibold text-base">Are you sure?</p>
//             <p className="text-sm text-gray-500 mt-1.5 leading-relaxed">
//               You are about to delete{" "}
//               <span className="font-semibold text-[#00032A]">{currentServiceName}</span>.
//               This action <span className="text-red-600 font-medium">cannot be undone</span>.
//             </p>
//           </div>

//           {/* Buttons */}
//           <div className="flex gap-3 w-full pt-1">
//             <button
//               onClick={() => setShowDeleteModal(false)}
//               disabled={isDeleting}
//               className="flex-1 px-4 py-2.5 text-sm font-medium bg-gray-100 rounded-xl hover:bg-gray-200 transition-colors disabled:opacity-50"
//             >
//               Cancel
//             </button>
//             <button
//               onClick={handleDeleteConfirm}
//               disabled={isDeleting}
//               className="flex-1 px-4 py-2.5 text-sm font-medium bg-red-600 text-white rounded-xl hover:bg-red-700 transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
//             >
//               {isDeleting ? (
//                 <>
//                   <span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
//                   Deleting...
//                 </>
//               ) : "Yes, Delete"}
//             </button>
//           </div>
//         </div>
//       </FleetrifyModal>
//     </DashboardLayout>
//   );
// };

// export default ViewService;


import { useMemo, useRef, useState, useEffect } from "react";
import { createPortal } from "react-dom";
import DashboardLayout from "../../../components/DashboardLayout";
import { useNavigate, useParams } from "react-router-dom";
import FleetrifyCard from "../../../components/Card";
import { FleetrifyButton } from "../../../components/Button/customButton";
import { FleetrifyModal } from "../../../components/Modal/modal";
import {
  useGetServiceByIdQuery,
  useGetAllServiceTypesQuery,
  useUpdateServiceMutation,
  useDeleteServiceMutation,
  ServiceRoute,
} from "../../../redux/services/serviceApi";
import { DAY_TO_DAY_SERVICE_NAME, dayToDayPriceError } from "../../../utils/servicePricing";
import { useStaffOptions } from "../../../hooks/useStaffOptions";
import { ArrowLeft, ChevronDown, Eye, Pencil, Plus, Printer, Trash2, X } from "lucide-react";
import { toast } from "sonner";
import { usePermission } from "../../../hooks/usePermission";


function useDropdownPosition(
  triggerRef: React.RefObject<HTMLElement | null>,
  open: boolean
) {
  const [pos, setPos] = useState({ top: 0, left: 0, width: 0 });
  useEffect(() => {
    if (!open || !triggerRef.current) return;
    const rect = triggerRef.current.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const dropdownH = 220;
    const top =
      spaceBelow < dropdownH
        ? rect.top + window.scrollY - dropdownH - 4
        : rect.bottom + window.scrollY + 4;
    setPos({ top, left: rect.left + window.scrollX, width: rect.width });
  }, [open, triggerRef]);
  return pos;
}

const PortalSelect = ({
  value, options, onChange, placeholder = "Select...", disabled = false,
}: {
  value: string;
  options: { label: string; value: string }[];
  onChange: (val: string) => void;
  placeholder?: string;
  disabled?: boolean;
}) => {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef<HTMLButtonElement>(null);
  const pos = useDropdownPosition(triggerRef, open);
  const selected = options.find((o) => o.value === value);

  return (
    <div className="w-full">
      <button ref={triggerRef} type="button" disabled={disabled}
        onClick={() => !disabled && setOpen((p) => !p)}
        className={`w-full flex items-center justify-between gap-2 px-3 py-2 text-sm border rounded-md bg-white transition-colors
          ${disabled ? "cursor-default border-gray-200 text-gray-400" : "border-gray-300 hover:border-[#143887] cursor-pointer"}
          ${open ? "border-[#143887] ring-1 ring-[#143887]/20" : ""}`}
      >
        <span className={selected ? "text-[#00032A]" : "text-gray-400"}>{selected?.label ?? placeholder}</span>
        <ChevronDown size={14} className={`text-gray-400 flex-shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && createPortal(
        <>
          <div className="fixed inset-0 z-[999]" onClick={() => setOpen(false)} />
          <div className="absolute bg-white border border-gray-200 rounded-md shadow-xl z-[1000] overflow-y-auto"
            style={{ top: pos.top, left: pos.left, width: pos.width, maxHeight: 220 }}>
            {options.map((opt) => (
              <button key={opt.value} type="button"
                onClick={() => { onChange(opt.value); setOpen(false); }}
                className={`w-full text-left px-4 py-2.5 text-sm hover:bg-[#e4ebf8] hover:text-[#143887] transition-colors
                  ${opt.value === value ? "bg-[#e4ebf8] text-[#143887] font-medium" : "text-[#00032A]"}`}>
                {opt.label}
              </button>
            ))}
          </div>
        </>,
        document.body
      )}
    </div>
  );
};


const PortalMultiSelect = ({
  value, options, onChange, placeholder = "Select options...", disabled = false,
}: {
  value: string[];
  options: { label: string; value: string }[];
  onChange: (vals: string[]) => void;
  placeholder?: string;
  disabled?: boolean;
}) => {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef<HTMLDivElement>(null);
  const pos = useDropdownPosition(triggerRef, open);

  const toggle = (val: string) =>
    onChange(value.includes(val) ? value.filter((v) => v !== val) : [...value, val]);
  const remove = (val: string, e: React.MouseEvent) => {
    e.stopPropagation();
    onChange(value.filter((v) => v !== val));
  };
  const getLabel = (val: string) => options.find((o) => o.value === val)?.label ?? val;

  return (
    <div className="w-full">
      <div ref={triggerRef} onClick={() => !disabled && setOpen((p) => !p)}
        className={`w-full min-h-[38px] flex flex-wrap items-center gap-1.5 px-3 py-1.5 border rounded-md bg-white transition-colors
          ${disabled ? "cursor-default border-gray-200" : "border-gray-300 hover:border-[#143887] cursor-pointer"}
          ${open ? "border-[#143887] ring-1 ring-[#143887]/20" : ""}`}>
        {value.length === 0 ? (
          <span className="text-sm text-gray-400 py-0.5">{placeholder}</span>
        ) : value.map((val) => (
          <span key={val} className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-[#e4ebf8] text-[#143887] text-xs font-medium border border-[#c5d5ef]">
            {getLabel(val)}
            {!disabled && (
              <button type="button" onClick={(e) => remove(val, e)} className="hover:text-red-500 transition-colors ml-0.5">
                <X size={10} />
              </button>
            )}
          </span>
        ))}
        {!disabled && (
          <ChevronDown size={14} className={`text-gray-400 ml-auto flex-shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />
        )}
      </div>
      {open && createPortal(
        <>
          <div className="fixed inset-0 z-[999]" onClick={() => setOpen(false)} />
          <div className="absolute bg-white border border-gray-200 rounded-md shadow-xl z-[1000] overflow-y-auto"
            style={{ top: pos.top, left: pos.left, width: pos.width, maxHeight: 220 }}>
            {options.map((opt) => {
              const sel = value.includes(opt.value);
              return (
                <button key={opt.value} type="button" onClick={() => toggle(opt.value)}
                  className={`w-full text-left px-4 py-2.5 text-sm flex items-center gap-2.5 hover:bg-[#e4ebf8] transition-colors
                    ${sel ? "text-[#143887] font-medium" : "text-[#00032A]"}`}>
                  <span className={`w-4 h-4 rounded border flex-shrink-0 flex items-center justify-center transition-colors
                    ${sel ? "bg-[#143887] border-[#143887]" : "border-gray-300 bg-white"}`}>
                    {sel && (
                      <svg viewBox="0 0 10 10" className="w-2.5 h-2.5 text-white" fill="none">
                        <path d="M1.5 5l2.5 2.5 5-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    )}
                  </span>
                  {opt.label}
                </button>
              );
            })}
          </div>
        </>,
        document.body
      )}
    </div>
  );
};


const EditableText = ({
  value, onSave, canEdit, type = "text", prefix,
}: {
  value: string; onSave: (val: string) => void; canEdit: boolean; type?: string; prefix?: string;
}) => {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value);
  const commit = () => { onSave(draft); setEditing(false); };

  if (editing) {
    return (
      <div className="flex items-center gap-1.5 w-full max-w-sm">
        {prefix && <span className="text-gray-600 font-semibold text-sm flex-shrink-0">{prefix}</span>}
        <input autoFocus type={type} value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onBlur={commit}
          onKeyDown={(e) => { if (e.key === "Enter") commit(); if (e.key === "Escape") setEditing(false); }}
          className="flex-1 text-sm text-[#00032A] border border-[#143887] rounded-md px-3 py-1.5 outline-none focus:ring-2 focus:ring-[#143887]/20 bg-white"
        />
      </div>
    );
  }

  return (
    <button type="button" disabled={!canEdit}
      onClick={() => { setDraft(value); setEditing(true); }}
      className="group flex items-center gap-2 text-left disabled:cursor-default">
      <span className="text-sm text-[#00032A] group-hover:text-[#143887] transition-colors">{prefix}{value}</span>
      {canEdit && (
        <Pencil size={12} className="text-gray-300 group-hover:text-[#143887] opacity-0 group-hover:opacity-100 transition-all flex-shrink-0" />
      )}
    </button>
  );
};


const FieldRow = ({ label, children }: { label: string; children: React.ReactNode }) => (
  <div className="flex flex-col md:flex-row md:items-start py-4 border-b border-gray-100 last:border-0 gap-1.5 md:gap-0">
    <span className="text-sm text-gray-500 font-medium md:w-56 md:flex-shrink-0 md:pt-1.5">{label}</span>
    <div className="flex-1 min-w-0">{children}</div>
  </div>
);


interface EditableRoute {
  id: string;
  from: string;
  to: string;
  price: string;
  staff_member_ids: string[];
  vehicle_type: string;
  isNew?: boolean;
}

const uid = () => Math.random().toString(36).slice(2, 9);

const EditableRouteCard = ({
  route,
  index,
  total,
  canEdit,
  onChange,
  onRemove,
  staffOptions,
  vehicleTypeOptions,
}: {
  route: EditableRoute;
  index: number;
  total: number;
  canEdit: boolean;
  onChange: (id: string, field: keyof Omit<EditableRoute, "id" | "isNew">, value: string | string[]) => void;
  onRemove: (id: string) => void;
  staffOptions: { label: string; value: string }[];
  vehicleTypeOptions: { label: string; value: string }[];
}) => {
  const formatPrice = (p: string) => {
    const num = parseFloat(p);
    if (isNaN(num)) return "0.00";
    return num.toLocaleString("en-NG", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  return (
    <div className="border border-gray-200 rounded-lg p-4 bg-gray-50 mb-3">
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs font-semibold text-[#143887] uppercase tracking-wide">
          Route {index + 1}
        </span>
        {canEdit && total > 1 && (
          <button
            type="button"
            onClick={() => onRemove(route.id)}
            className="flex items-center gap-1 text-xs text-red-500 hover:text-red-700 transition-colors"
          >
            <Trash2 size={13} />
            Remove
          </button>
        )}
      </div>

      {/* From / To */}
      <div className="flex flex-col md:flex-row md:gap-3 gap-3 mb-3">
        <div className="flex-1">
          <label className="block text-xs font-medium mb-1.5 text-gray-500">From</label>
          {canEdit ? (
            <input
              type="text"
              value={route.from}
              onChange={(e) => onChange(route.id, "from", e.target.value)}
              placeholder="Starting location"
              className="w-full px-3 py-2 border border-gray-300 rounded-md bg-white text-sm focus:outline-none focus:ring-[0.5px] focus:ring-[#143887] focus:border-[#143887] hover:border-[#143887] transition-colors"
            />
          ) : (
            <span className="text-sm text-[#00032A]">{route.from || "—"}</span>
          )}
        </div>
        <div className="flex-1">
          <label className="block text-xs font-medium mb-1.5 text-gray-500">To</label>
          {canEdit ? (
            <input
              type="text"
              value={route.to}
              onChange={(e) => onChange(route.id, "to", e.target.value)}
              placeholder="Destination"
              className="w-full px-3 py-2 border border-gray-300 rounded-md bg-white text-sm focus:outline-none focus:ring-[0.5px] focus:ring-[#143887] focus:border-[#143887] hover:border-[#143887] transition-colors"
            />
          ) : (
            <span className="text-sm text-[#00032A]">{route.to || "—"}</span>
          )}
        </div>
      </div>

      {/* Price */}
      <div>
        <label className="block text-xs font-medium mb-1.5 text-gray-500">Fixed Price</label>
        {canEdit ? (
          <div className="relative">
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-600 font-semibold text-sm">₦</span>
            <input
              type="number"
              value={route.price}
              onChange={(e) => onChange(route.id, "price", e.target.value.replace(/[^0-9.]/g, ""))}
              placeholder="0.00"
              min={0}
              className="w-full pl-8 pr-3 py-2 border border-gray-300 rounded-md bg-white text-sm focus:outline-none focus:ring-[0.5px] focus:ring-[#143887] focus:border-[#143887] hover:border-[#143887] transition-colors"
            />
          </div>
        ) : (
          <span className="text-sm text-[#00032A] font-medium">₦{formatPrice(route.price)}</span>
        )}
      </div>

      {/* Vehicle type for this route */}
      <div className="mt-3">
        <label className="block text-xs font-medium mb-1.5 text-gray-500">Vehicle Type</label>
        {canEdit ? (
          <PortalSelect
            value={route.vehicle_type}
            options={vehicleTypeOptions}
            onChange={(val) => onChange(route.id, "vehicle_type", val)}
            placeholder="Select a vehicle type for this route"
          />
        ) : (
          <span className="text-sm text-[#00032A]">
            {vehicleTypeOptions.find((o) => o.value === route.vehicle_type)?.label || route.vehicle_type || "—"}
          </span>
        )}
      </div>

      {/* Staff members for this route */}
      <div className="mt-3">
        <label className="block text-xs font-medium mb-1.5 text-gray-500">Staff Members</label>
        {canEdit ? (
          <PortalMultiSelect
            value={route.staff_member_ids}
            options={staffOptions}
            onChange={(vals) => onChange(route.id, "staff_member_ids", vals)}
            placeholder="Assign staff members with the Role of Driver to this route"
          />
        ) : (
          <span className="text-sm text-[#00032A]">
            {route.staff_member_ids.length > 0
              ? route.staff_member_ids
                  .map((id) => staffOptions.find((o) => o.value === id)?.label || id)
                  .join(", ")
              : "—"}
          </span>
        )}
      </div>
    </div>
  );
};


const ViewService = () => {
  const navigate = useNavigate();
  const { serviceId } = useParams<{ serviceId: string }>();

  const [isActive, setIsActive] = useState<boolean | null>(null);
  const [hasStatusChanged, setHasStatusChanged] = useState(false);
  const [hasFieldChanges, setHasFieldChanges] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);

  const [editedServiceTypeId, setEditedServiceTypeId] = useState<string | null>(null);
  const [editedDescription, setEditedDescription] = useState<string | null>(null);
  const [editedPrice, setEditedPrice] = useState<string | null>(null);
  const [editedPriceModel, setEditedPriceModel] = useState<string | null>(null);
  const [editedVehicleTypes, setEditedVehicleTypes] = useState<string[] | null>(null);
  const [editedStaffMembers, setEditedStaffMembers] = useState<string[] | null>(null);

  const [editedRoutes, setEditedRoutes] = useState<EditableRoute[] | null>(null);

  const { data: selectedService, isLoading, isError } = useGetServiceByIdQuery(serviceId!, { skip: !serviceId });
  const { data: serviceTypes } = useGetAllServiceTypesQuery(undefined, { skip: !selectedService });

  const PRICE_MODEL_OPTIONS = [
    { label: "Dynamic", value: "dynamic" },
    { label: "Fixed", value: "fixed" },
  ];

  const VEHICLE_TYPE_OPTIONS = [
    { label: "Car", value: "car" },
    { label: "Truck", value: "truck" },
    { label: "Bike", value: "bike" },
    { label: "Van", value: "van" },
  ];

  const staffOptions = useStaffOptions();

  const serviceCategoryOptions = useMemo(() =>
    (serviceTypes ?? []).map((t) => ({ label: t.name, value: t.id })),
    [serviceTypes]);

  const isRelocationIds = useMemo(() =>
    (serviceTypes ?? [])
      .filter((t) => t.name === "Local Relocation" || t.name === "State Relocation")
      .map((t) => t.id),
    [serviceTypes]);

  const currentServiceTypeId = editedServiceTypeId ?? selectedService?.service_type_id ?? "";
  const isRelocation = isRelocationIds.includes(currentServiceTypeId);
  const dayToDayTypeId = (serviceTypes ?? []).find((t) => t.name === DAY_TO_DAY_SERVICE_NAME)?.id;
  const isDayToDay = !!dayToDayTypeId && currentServiceTypeId === dayToDayTypeId;


  useEffect(() => {
    if (!selectedService) return;
    setEditedRoutes(
      (selectedService.routes ?? []).map((r: any) => ({
        id: r.id ?? uid(),
        from: r.from,
        to: r.to,
        price: String(r.price),
        staff_member_ids: r.staff_member_ids ?? [],
        vehicle_type: r.vehicle_type ?? "",
      }))
    );
    setEditedServiceTypeId(null);
    setEditedDescription(null);
    setEditedPrice(null);
    setEditedPriceModel(null);
    setEditedVehicleTypes(null);
    setEditedStaffMembers(null);
    setHasFieldChanges(false);
    setHasStatusChanged(false);
  }, [selectedService?.id]);

  const currentRoutes: EditableRoute[] = useMemo(() => {
    if (editedRoutes !== null) return editedRoutes;
    return (selectedService?.routes ?? []).map((r: any) => ({
      id: r.id ?? uid(),
      from: r.from,
      to: r.to,
      price: String(r.price),
      staff_member_ids: r.staff_member_ids ?? [],
      vehicle_type: r.vehicle_type ?? "",
    }));
  }, [editedRoutes, selectedService]);

  const [updateService, { isLoading: isUpdatingService }] = useUpdateServiceMutation();
  const [deleteService] = useDeleteServiceMutation();
  const { hasPermission } = usePermission();
  const canUpdate = hasPermission("update service");
  const canDelete = hasPermission("delete service");

  const initialIsActive = String(selectedService?.status ?? "active").toLowerCase() !== "inactive";
  const currentIsActive = isActive ?? initialIsActive;
  const mark = () => setHasFieldChanges(true);

  const currentVehicleTypes: string[] = useMemo(() => {
    if (editedVehicleTypes !== null) return editedVehicleTypes;
    const raw = selectedService?.vehicle_type ?? "";
    return raw ? raw.split(",").map((v: string) => v.trim()).filter(Boolean) : [];
  }, [editedVehicleTypes, selectedService]);

  const currentStaffMembers: string[] = editedStaffMembers ?? selectedService?.staff_members_id ?? [];
  const serviceTypeName = serviceCategoryOptions.find((o) => o.value === currentServiceTypeId)?.label || "—";
  const currentServiceName = selectedService?.service_type_name ?? serviceTypeName ?? "—";

  const formatDate = (d: string) => {
    try { return new Date(d).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" }); }
    catch { return d; }
  };

  const formatPrice = (p: string) => {
    try { return parseFloat(editedPrice ?? p).toLocaleString("en-NG", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    catch { return p; }
  };

  const capitalize = (s: string) => s ? s.charAt(0).toUpperCase() + s.slice(1) : "N/A";

  const handleRouteChange = (id: string, field: keyof Omit<EditableRoute, "id" | "isNew">, value: string | string[]) => {
    setEditedRoutes((prev) =>
      (prev ?? currentRoutes).map((r) => r.id === id ? { ...r, [field]: value } : r)
    );
    mark();
  };

  const addRoute = () => {
    setEditedRoutes((prev) => [
      ...(prev ?? currentRoutes),
      { id: uid(), from: "", to: "", price: "", staff_member_ids: [], vehicle_type: "", isNew: true },
    ]);
    mark();
  };

  const removeRoute = (id: string) => {
    setEditedRoutes((prev) => (prev ?? currentRoutes).filter((r) => r.id !== id));
    mark();
  };

  // Day-to-Day Delivery has a minimum base price — check the price it will end up with
  // whenever the price or the service type is being changed. Also disables Update.
  const dayToDayMinError = (() => {
    if (!isDayToDay || !selectedService || (editedPrice === null && !editedServiceTypeId)) return null;
    const effectivePrice =
      editedPrice ??
      (selectedService.base_price && selectedService.base_price !== "0.00" ? selectedService.base_price : selectedService.price);
    return dayToDayPriceError(effectivePrice);
  })();

  const handleUpdate = async () => {
    if (!service) return;
    if (!canUpdate) { toast.error("You don't have permission to update a service"); return; }
    if (!hasStatusChanged && !hasFieldChanges) { toast.info("No changes to update"); return; }

    // Validate routes for relocation
    if (isRelocation && editedRoutes !== null) {
      for (let i = 0; i < editedRoutes.length; i++) {
        const r = editedRoutes[i];
        if (!r.from.trim()) { toast.error(`Route ${i + 1}: starting location is required`); return; }
        if (!r.to.trim()) { toast.error(`Route ${i + 1}: destination is required`); return; }
        if (!r.price || parseFloat(r.price) <= 0) { toast.error(`Route ${i + 1}: a valid price is required`); return; }
        if (r.staff_member_ids.length === 0) { toast.error(`Route ${i + 1}: at least one staff member must be assigned.`); return; }
        if (!r.vehicle_type) { toast.error(`Route ${i + 1}: a vehicle type must be assigned.`); return; }
      }
    }

    if (dayToDayMinError) { toast.error(dayToDayMinError); return; }

    const payload: any = {};
    if (hasStatusChanged) payload.status = currentIsActive ? "active" : "inactive";
    if (editedServiceTypeId) payload.service_type_id = editedServiceTypeId;
    if (editedDescription !== null) payload.description = editedDescription;
    if (editedPriceModel !== null) payload.price_model = editedPriceModel;
    if (!isRelocation && editedVehicleTypes !== null) payload.vehicle_type = editedVehicleTypes.join(", ");
    if (!isRelocation && editedStaffMembers !== null) payload.staff_members_id = editedStaffMembers;

    // Relocation — send routes array (with per-route staff/vehicle type), plus
    // a top-level summary derived from the routes; dispatch — send base_price
    if (isRelocation && editedRoutes !== null) {
      payload.vehicle_type = editedRoutes[0]?.vehicle_type || "";
      payload.staff_members_id = Array.from(
        new Set(editedRoutes.flatMap((r) => r.staff_member_ids))
      );
      payload.routes = editedRoutes.map((r) => ({
        from: r.from.trim(),
        to: r.to.trim(),
        price: parseFloat(r.price),
        staff_member_ids: r.staff_member_ids,
        vehicle_type: r.vehicle_type,
      }));
    } else if (!isRelocation && editedPrice !== null) {
      payload.base_price = editedPrice;
    }

    try {
      await updateService({ id: service.id, payload }).unwrap();
      toast.success("Service updated successfully!");
      setTimeout(() => navigate("/services"), 500);
    } catch (error: any) {
      toast.error(error?.data?.message || "Failed to update service");
    }
  };

  const handleDeleteConfirm = async () => {
    if (!service) return;
    if (!canDelete) { toast.error("You don't have permission to delete a service"); return; }
    try {
      setIsDeleting(true);
      setIsDeleted(true);
      await deleteService(service.id).unwrap();
      toast.success("Service deleted successfully!");
      setShowDeleteModal(false);
      navigate("/services");
    } catch (error: any) {
      setIsDeleted(false);
      toast.error(error?.data?.message || "Failed to delete service");
    } finally {
      setIsDeleting(false);
    }
  };

  if (isLoading) {
    return (
      <DashboardLayout title="Services" containerClass="pb-10">
        <FleetrifyCard cardContainerClass="mt-5 mb-10">
          <div className="flex flex-col items-center justify-center py-20">
            <div className="h-10 w-10 border-4 border-gray-300 border-t-[#143887] rounded-full animate-spin" />
            <p className="text-sm text-gray-500 mt-4">Loading service details...</p>
          </div>
        </FleetrifyCard>
      </DashboardLayout>
    );
  }

  if (!isDeleted && (isError || !selectedService)) {
    return (
      <DashboardLayout title="Service Not Found">
        <FleetrifyCard cardContainerClass="mt-5 mb-10">
          <div className="flex flex-col items-center justify-center py-20">
            <div className="text-6xl text-gray-300 mb-4">🔍</div>
            <h2 className="text-2xl font-bold text-gray-700 mb-2">Service Not Found</h2>
            <p className="text-gray-500 mb-6">The service you're looking for does not exist.</p>
            <FleetrifyButton onClick={() => navigate("/services")} className="bg-[#143887] hover:bg-[#0f2d6b]">
              Back to Services
            </FleetrifyButton>
          </div>
        </FleetrifyCard>
      </DashboardLayout>
    );
  }

  const hasAnyChange = hasStatusChanged || hasFieldChanges;
  const service = selectedService!;

  return (
    <DashboardLayout title="Services" containerClass="pb-10">
      <div className="mt-5 mb-4">
        <button onClick={() => navigate("/services")}
          className="flex items-center gap-2 text-sm text-gray-500 hover:text-[#143887] font-medium transition-colors group">
          <span className="flex items-center justify-center w-7 h-7 rounded-full border border-gray-200 group-hover:border-[#143887] group-hover:bg-[#e4ebf8] transition-all">
            <ArrowLeft size={14} />
          </span>
          Back to Services
        </button>
      </div>

      <FleetrifyCard cardContainerClass="mb-10">
        {/* Header */}
        <div className="px-4 md:px-6 py-4 border-b border-gray-200 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="p-1.5 rounded-sm bg-[#e4ebf8]">
              <Eye size={20} className="text-[#143887]" />
            </div>
            {hasAnyChange && (
              <span className="text-xs text-orange-500 font-medium bg-orange-50 border border-orange-200 px-2 py-0.5 rounded-full">
                Unsaved changes
              </span>
            )}
          </div>
          <div className="flex items-center gap-3">
            <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border ${
              currentIsActive ? "bg-green-50 text-green-700 border-green-200" : "bg-red-50 text-red-600 border-red-200"
            }`}>
              <span className={`w-1.5 h-1.5 rounded-full ${currentIsActive ? "bg-green-500" : "bg-red-500"}`} />
              {currentIsActive ? "Active" : "Inactive"}
            </span>
            <button onClick={() => window.print()} className="text-gray-500 p-2 bg-gray-100 rounded-sm hover:bg-gray-200 transition-colors">
              <Printer size={16} />
            </button>
          </div>
        </div>

        {/* Body */}
        <div className="px-4 md:px-6 py-4">
          {canUpdate && (
            <p className="text-xs text-gray-400 mb-2 flex items-center gap-1">
              <Pencil size={11} /> Click any value to edit
            </p>
          )}

          <FieldRow label="Service">
            <span className="text-sm text-[#00032A]">{currentServiceName}</span>
          </FieldRow>

          <FieldRow label="Service Category">
            <PortalSelect value={currentServiceTypeId} options={serviceCategoryOptions}
              onChange={(val) => { setEditedServiceTypeId(val); mark(); }}
              placeholder="Select category" disabled={!canUpdate} />
          </FieldRow>

          <FieldRow label="Description">
            <EditableText value={editedDescription ?? service.description ?? ""}
              onSave={(v) => { setEditedDescription(v); mark(); }} canEdit={canUpdate} />
          </FieldRow>

          {/* ── RELOCATION: editable route cards ── */}
          {isRelocation ? (
            <FieldRow label="Routes">
              <div className="w-full">
                {currentRoutes.length === 0 ? (
                  <p className="text-sm text-gray-400 italic mb-3">No routes added yet.</p>
                ) : (
                  currentRoutes.map((route, index) => (
                    <EditableRouteCard
                      key={route.id}
                      route={route}
                      index={index}
                      total={currentRoutes.length}
                      canEdit={canUpdate}
                      onChange={handleRouteChange}
                      onRemove={removeRoute}
                      staffOptions={staffOptions}
                      vehicleTypeOptions={VEHICLE_TYPE_OPTIONS}
                    />
                  ))
                )}
                {canUpdate && (
                  <button
                    type="button"
                    onClick={addRoute}
                    className="flex items-center gap-2 text-sm text-[#143887] font-medium hover:text-[#0f2a66] transition-colors mt-1"
                  >
                    <div className="w-6 h-6 rounded-full border border-[#143887] flex items-center justify-center">
                      <Plus size={13} />
                    </div>
                    Add another route
                  </button>
                )}
              </div>
            </FieldRow>
          ) : (
            /* ── DISPATCH: single base_price ── */
            <FieldRow label="Price">
              <EditableText
                value={formatPrice(service.base_price === "0.00" || !service.base_price ? service.price : service.base_price)}
                onSave={(v) => { setEditedPrice(v); mark(); }}
                canEdit={canUpdate}
                type="number"
                prefix="₦"
              />
              {dayToDayMinError && (
                <p className="mt-1 text-xs font-medium text-red-600">{dayToDayMinError}</p>
              )}
            </FieldRow>
          )}

          <FieldRow label="Price Model">
            <PortalSelect value={editedPriceModel ?? service.price_model ?? ""}
              options={PRICE_MODEL_OPTIONS}
              onChange={(val) => { setEditedPriceModel(val); mark(); }}
              placeholder="Select price model" disabled={!canUpdate} />
          </FieldRow>

          {!isRelocation && (
            <FieldRow label="Vehicle Type">
              <PortalMultiSelect value={currentVehicleTypes} options={VEHICLE_TYPE_OPTIONS}
                onChange={(vals) => { setEditedVehicleTypes(vals); mark(); }}
                placeholder="Select vehicle types" disabled={!canUpdate} />
            </FieldRow>
          )}

          {!isRelocation && (
            <FieldRow label="Staff Members">
              <PortalMultiSelect value={currentStaffMembers} options={staffOptions}
                onChange={(vals) => { setEditedStaffMembers(vals); mark(); }}
                placeholder="Select staff members" disabled={!canUpdate} />
            </FieldRow>
          )}

          <FieldRow label="Date Added">
            <span className="text-sm text-[#00032A]">{formatDate(service.created_at)}</span>
          </FieldRow>

          {/* Action buttons */}
          <div className="flex flex-col sm:flex-row gap-3 mt-6 pt-4 border-t border-gray-100">
            <FleetrifyButton variant="outline"
              className="w-full sm:w-32 border-[#143887] text-[#143887] hover:bg-[#143887] hover:text-white transition-colors"
              onClick={handleUpdate} disabled={isUpdatingService || !canUpdate || !!dayToDayMinError}
              title={dayToDayMinError ?? undefined}>
              {isUpdatingService ? "Updating..." : "Update"}
            </FleetrifyButton>
            <FleetrifyButton variant="destructive"
              className="w-full sm:w-32 bg-red-600 hover:bg-red-700"
              onClick={() => {
                if (!canDelete) { toast.error("You don't have permission to delete a service"); return; }
                setShowDeleteModal(true);
              }}
              disabled={isUpdatingService || !canDelete}>
              Delete
            </FleetrifyButton>
          </div>
        </div>
      </FleetrifyCard>

      {/* Delete confirmation modal */}
      <FleetrifyModal
        isOpen={showDeleteModal}
        title="Delete Service"
        onClose={() => setShowDeleteModal(false)}
        className="max-w-md h-fit"
        enableOutsideClick={false}
      >
        <div className="flex flex-col items-center justify-center p-6 text-center space-y-4">
          <div className="w-14 h-14 rounded-full bg-red-50 border border-red-200 flex items-center justify-center">
            <Trash2 size={22} className="text-red-500" />
          </div>
          <div>
            <p className="text-gray-800 font-semibold text-base">Are you sure?</p>
            <p className="text-sm text-gray-500 mt-1.5 leading-relaxed">
              You are about to delete{" "}
              <span className="font-semibold text-[#00032A]">{currentServiceName}</span>.
              This action <span className="text-red-600 font-medium">cannot be undone</span>.
            </p>
          </div>
          <div className="flex gap-3 w-full pt-1">
            <button onClick={() => setShowDeleteModal(false)} disabled={isDeleting}
              className="flex-1 px-4 py-2.5 text-sm font-medium bg-gray-100 rounded-xl hover:bg-gray-200 transition-colors disabled:opacity-50">
              Cancel
            </button>
            <button onClick={handleDeleteConfirm} disabled={isDeleting}
              className="flex-1 px-4 py-2.5 text-sm font-medium bg-red-600 text-white rounded-xl hover:bg-red-700 transition-colors disabled:opacity-50 flex items-center justify-center gap-2">
              {isDeleting ? (
                <>
                  <span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                  Deleting...
                </>
              ) : "Yes, Delete"}
            </button>
          </div>
        </div>
      </FleetrifyModal>
    </DashboardLayout>
  );
};

export default ViewService;